// Define types for your enums and form data
export interface EnumOption {
    constant: string;
    value: string;
}

export let priorityCategories = [
    {value: "Low", constant: "Low"},
    {value: "Medium", constant: "Medium"},
    {value: "High", constant: "High"},
    {value: "Extreme", constant: "Extreme"}
]